var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"gif--container",attrs:{"id":"grid"}},[_c('div',{staticClass:"firework",staticStyle:{"left":"15%","top":"5%"}}),_c('div',{staticClass:"firework"}),_c('div',{staticClass:"firework"}),_c('div',{staticClass:"winning_img",class:{
			'winning-image-kids': _vm.gameMode === 'kids',
			'winning-image-adults': _vm.gameMode === 'adults',
		}}),_c('div',{staticClass:"firework"}),_c('div',{staticClass:"firework"}),_c('div',{staticClass:"firework"})])
}
var staticRenderFns = []

export { render, staticRenderFns }